import { useEffect, useState } from "react";
import { Outlet, Route, Routes, useLocation, Navigate } from "react-router-dom";
import Header, { NavLink } from "components/Header/Header";

import { BrandsPage } from "./pages/Brands";
import { CountriesPage } from "./pages/Countries";
import { ProductsPage } from "./pages/Products";
import { ImagesPage } from "./pages/Images";
import { useIntl } from "react-intl";
import TagManager from "react-gtm-module";

export function AdminPage({ user }: any) {
  const [navLinks, setNavLinks] = useState<NavLink[]>([]);
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: location.pathname + location.search,
      },
    })
  }, [location.pathname, location.search]);

  useEffect(() => {
    const links: NavLink[] = [];
    const isGlobalAdmin = user.roles.includes('global-admin');
    const isCountryAdmin = user.roles.includes('country-admin');

    if (isGlobalAdmin) {
      links.push({ title: intl.formatMessage({ id: 'app.heading.brands' }), to: '/brands', active: location.pathname.includes('/brands') });
    }

    if (isGlobalAdmin || isCountryAdmin) {
      links.push({ title: intl.formatMessage({id: 'app.heading.countries'}), to: '/countries', active: location.pathname.includes('/countries') });
      links.push({ title: intl.formatMessage({id: 'app.heading.products'}), to: '/products', active: location.pathname.includes('/products') });
      links.push({ title: intl.formatMessage({id: 'app.heading.images'}), to: '/images', active: location.pathname.includes('/images') });
      links.push({ title: intl.formatMessage({id: 'app.heading.viewApp'}), to: '/mobile', active: location.pathname.includes('/mobile') });
    }

    setNavLinks(links);
  }, [location, user, intl]);

  return (
    <>
      <Header user={user} navLinks={navLinks} />
      <Outlet />
      <Routes>
        <Route path="brands" element={<BrandsPage />}></Route>
        <Route path="countries" element={<CountriesPage />}></Route>
        <Route path="products" element={<ProductsPage />}></Route>
        <Route path="images" element={<ImagesPage user={user} />}></Route>
        <Route index element={navLinks.length && <Navigate replace to={navLinks[0].to} />}></Route>
      </Routes>
    </>
  );
}
